/**
 * Updates the title of the webpage with the provided h1 value.
 * @param {Object} meta_data - The options object.
 * @param {string} meta_data.h1 - The new value for the h1 element.
 */
const updateH1 = ({ h1 }) => {
  const title = document.querySelector(".wb-head .wb-title")
  h1 && title && (title.textContent = h1)
}

export default updateH1
